export default __webpack_public_path__ + "static/media/cbcComedor.97f4d137.jpg";